import { render, staticRenderFns } from "./mutationPreviewDropzone.vue?vue&type=template&id=5ec44c99&scoped=true"
import script from "./mutationPreviewDropzone.vue?vue&type=script&lang=js"
export * from "./mutationPreviewDropzone.vue?vue&type=script&lang=js"
import style0 from "./mutationPreviewDropzone.vue?vue&type=style&index=0&id=5ec44c99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec44c99",
  null
  
)

export default component.exports